module.exports = __webpack_public_path__ + "static/media/aztec-secret-logo.9b686dbe.png";